export default __webpack_public_path__ + "static/media/money.58473695.png";